import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goregaontopunecabs() {



  const cardData = {


  keyword: "Goregaon to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Goregaon to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth highway travel, and a hassle-free journey from Goregaon to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to meet every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Goregaon to Pune taxi services.",

  topPlaces: [
    {
      title: "Aundh",
      description: "Aundh is a premium Pune locality known for corporate offices, educational institutions, hospitals, shopping areas, restaurants, and modern residential developments. It is a preferred destination for professionals and families."
    },
    {
      title: "Tathawade",
      description: "Tathawade is an emerging Pune suburb featuring residential projects, educational institutions, commercial developments, and easy connectivity to Hinjewadi and Pimpri Chinchwad business areas."
    },
    {
      title: "Kharadi",
      description: "Kharadi is a major IT and corporate hub in Pune, home to EON IT Park, multinational companies, financial organizations, and modern office spaces. It attracts business travelers throughout the year."
    },
    {
      title: "Bhosari MIDC",
      description: "Bhosari MIDC is an important industrial destination in Pune known for engineering companies, automobile businesses, manufacturing units, and warehouses. It is a key location for industrial and corporate travel."
    },
    {
      title: "Balewadi",
      description: "Balewadi is a fast-growing commercial and lifestyle destination in Pune featuring Balewadi High Street, business spaces, restaurants, sports facilities, and premium residential projects."
    },
    {
      title: "Viman Nagar",
      description: "Viman Nagar is a premium Pune locality near the airport, known for IT companies, hotels, shopping malls, restaurants, and commercial spaces. It is popular among business travelers and visitors."
    },
    {
      title: "Raja Dinkar Kelkar Museum",
      description: "Raja Dinkar Kelkar Museum is a famous cultural attraction in Pune showcasing traditional Indian art, antiques, sculptures, and historical collections. It is a popular destination for heritage lovers."
    },
    {
      title: "Pataleshwar Cave Temple",
      description: "Pataleshwar Cave Temple is an ancient rock-cut temple in Pune featuring historic stone carvings and unique architecture. It attracts tourists interested in history, culture, and spirituality."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a beautiful hill station between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and lush green valleys. It is a popular getaway destination for families and travelers."
    },
    {
      title: "Karla Caves",
      description: "Karla Caves are ancient Buddhist rock-cut monuments near Lonavala known for impressive architecture, historical carvings, and cultural importance. They are a popular sightseeing destination on the Mumbai-Pune route."
    }
  ],






"services": [
  {
    "name": "Goregaon to Pune Pimpri Chinchwad Cab",
    "description": "Book Goregaon to Pune Pimpri Chinchwad Cab for comfortable intercity travel with professional chauffeurs, clean AC vehicles, affordable fares, doorstep pickup, and reliable transportation."
  },
  {
    "name": "Goregaon to Pune One Way Cab",
    "description": "Choose Goregaon to Pune One Way Cab for direct destination travel with fixed pricing, comfortable seating, experienced drivers, and hassle-free booking."
  },
  {
    "name": "Goregaon to Pune Taxi Service",
    "description": "Reserve Goregaon to Pune Taxi Service with premium cars, professional chauffeurs, transparent pricing, and safe highway travel for business and family trips."
  },
  {
    "name": "Taxi Service in Goregaon Mumbai",
    "description": "Get Taxi Service in Goregaon Mumbai for local and outstation travel with reliable drivers, clean vehicles, affordable rates, and quick booking support."
  },
  {
    "name": "Cabs Service Goregaon Mumbai",
    "description": "Book Cabs Service Goregaon Mumbai for airport transfers, outstation journeys, corporate travel, and personal trips with comfortable AC vehicles."
  },
  {
    "name": "Malad to Pune Cab Services",
    "description": "Choose Malad to Pune Cab Services for safe intercity transportation with experienced chauffeurs, multiple vehicle options, and affordable travel packages."
  },
  {
    "name": "Oshiwara Andheri to Pune Taxi Booking",
    "description": "Complete Oshiwara Andheri to Pune Taxi Booking with easy reservation, professional drivers, clean cars, and reliable pickup service."
  },
  {
    "name": "Goregaon to Hinjewadi Cabs",
    "description": "Book Goregaon to Hinjewadi Cabs for corporate and personal travel with comfortable vehicles, experienced chauffeurs, and smooth highway journeys."
  },
  {
    "name": "Goregaon to Pimpri Chinchwad Cab Fare",
    "description": "Check Goregaon to Pimpri Chinchwad Cab Fare with transparent pricing, affordable packages, and multiple vehicle choices."
  },
  {
    "name": "Goregaon to Swargate Cab",
    "description": "Reserve Goregaon to Swargate Cab for convenient travel with AC cars, professional drivers, flexible schedules, and reliable service."
  },
  {
    "name": "Cab Services in Goregaon Mumbai",
    "description": "Book Cab Services in Goregaon Mumbai for outstation trips, airport transfers, and daily travel with safe and comfortable vehicles."
  },
  {
    "name": "Taxi Service in Gurgaon for Outstation",
    "description": "Choose Taxi Service in Gurgaon for Outstation travel with professional chauffeurs, premium vehicles, and affordable long-distance transportation."
  },
  {
    "name": "Goregaon to Pune Cab",
    "description": "Book Goregaon to Pune Cab for reliable travel with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options."
  },
  {
    "name": "Goregaon to Pune Taxi",
    "description": "Choose Goregaon to Pune Taxi for comfortable journeys with clean AC vehicles, trained drivers, and transparent fares."
  },
  {
    "name": "Goregaon to Pune Cab Service",
    "description": "Get Goregaon to Pune Cab Service with doorstep pickup, professional chauffeurs, affordable pricing, and dependable transportation."
  },
  {
    "name": "Goregaon to Pune Taxi Booking",
    "description": "Complete Goregaon to Pune Taxi Booking online with instant confirmation, multiple cars, and reliable chauffeur-driven service."
  },
  {
    "name": "Goregaon to Pune Drop Taxi",
    "description": "Book Goregaon to Pune Drop Taxi for one-way travel with direct destination drop, fixed fares, and comfortable vehicles."
  },
  {
    "name": "Goregaon to Pune Online Cab Booking",
    "description": "Use Goregaon to Pune Online Cab Booking for quick reservation, secure booking, affordable fares, and professional drivers."
  },
  {
    "name": "Goregaon to Pune Private Cab",
    "description": "Hire Goregaon to Pune Private Cab for exclusive travel with privacy, flexible timing, premium cars, and experienced chauffeurs."
  },
  {
    "name": "Goregaon to Pune Outstation Cab",
    "description": "Choose Goregaon to Pune Outstation Cab for safe highway travel with AC vehicles, professional drivers, and reliable service."
  },
  {
    "name": "Goregaon to Pune Cheap Cab",
    "description": "Book Goregaon to Pune Cheap Cab with budget-friendly fares, quality vehicles, and dependable intercity travel."
  },
  {
    "name": "Goregaon to Pune AC Cab Service",
    "description": "Travel comfortably with Goregaon to Pune AC Cab Service featuring clean air-conditioned vehicles and professional chauffeurs."
  },
  {
    "name": "Goregaon to Pune Innova Cab",
    "description": "Reserve Goregaon to Pune Innova Cab for family and group travel with spacious seating, luggage space, and premium comfort."
  },
  {
    "name": "Goregaon to Pune Taxi Fare",
    "description": "Check Goregaon to Pune Taxi Fare with transparent rates, flexible packages, and affordable vehicle options."
  },
  {
    "name": "Goregaon East to Pune Cab",
    "description": "Book Goregaon East to Pune Cab with reliable pickup, experienced drivers, and comfortable AC cars."
  },
  {
    "name": "Goregaon West to Pune Cab",
    "description": "Choose Goregaon West to Pune Cab for safe transportation with professional chauffeurs, premium vehicles, and affordable fares."
  }
],

"tableData": [
  ["Goregaon to Pune Pimpri Chinchwad Cab", "Goregaon to Pune One Way Cab"],
  ["Goregaon to Pune Taxi Service", "Taxi Service in Goregaon Mumbai"],
  ["Cabs Service Goregaon Mumbai", "Malad to Pune Cab Services"],
  ["Oshiwara Andheri to Pune Taxi Booking", "Goregaon to Hinjewadi Cabs"],
  ["Goregaon to Pimpri Chinchwad Cab Fare", "Goregaon to Swargate Cab"],
  ["Cab Services in Goregaon Mumbai", "Taxi Service in Gurgaon for Outstation"],
  ["Goregaon to Pune Cab", "Goregaon to Pune Taxi"],
  ["Goregaon to Pune Cab Service", "Goregaon to Pune Taxi Booking"],
  ["Goregaon to Pune Drop Taxi", "Goregaon to Pune Online Cab Booking"],
  ["Goregaon to Pune Private Cab", "Goregaon to Pune Outstation Cab"],
  ["Goregaon to Pune Cheap Cab", "Goregaon to Pune AC Cab Service"],
  ["Goregaon to Pune Innova Cab", "Goregaon to Pune Taxi Fare"],
  ["Goregaon East to Pune Cab", "Goregaon West to Pune Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Goregaon to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable Goregaon to Pune cab services with professional drivers, quality vehicles, and smooth travel solutions for every passenger."
  },
  {
    WhyChooseheading: "Easy Pickup from Goregaon",
    WhyChoosedescription: "Get convenient pickup from Goregaon East, Goregaon West, offices, hotels, residential areas, and nearby locations with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai Pune Journey",
    WhyChoosedescription: "Our trained chauffeurs ensure safe and comfortable travel with excellent knowledge of the Mumbai-Pune route and highway conditions."
  },
  {
    WhyChooseheading: "Comfortable Cars for Every Need",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on passenger count and travel requirements."
  },
  {
    WhyChooseheading: "Affordable Goregaon Pune Cab Fare",
    WhyChoosedescription: "Enjoy competitive cab pricing with transparent fare details and no hidden charges before confirming your booking."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Book one-way cabs, return trips, or customized travel packages according to your travel schedule and destination needs."
  },
  {
    WhyChooseheading: "Perfect for Corporate & Family Travel",
    WhyChoosedescription: "Our Goregaon to Pune cabs are ideal for business meetings, office travel, airport transfers, family trips, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Get quick support, instant confirmation, and reliable assistance whenever you need a cab from Goregaon to Pune."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Goregaon to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Goregaon to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Goregaon to Pune?",
    answer: "Yes, one-way cab booking is available from Goregaon to Pune with flexible pickup and drop options."
  },
  {
    question: "Do you provide pickup from Goregaon East and Goregaon West?",
    answer: "Yes, we provide pickup from both Goregaon East and Goregaon West along with nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Goregaon to Pune travel?",
    answer: "We offer Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to travel requirements."
  },
  {
    question: "Can I book a Goregaon to Pune cab from Mumbai Airport area?",
    answer: "Yes, we provide convenient airport pickup services from Goregaon and Mumbai Airport areas to Pune."
  },
  {
    question: "Is Goregaon to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 for comfortable travel at any preferred time."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Can I schedule my Goregaon to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup timing."
  },
  {
    question: "Do you provide Goregaon to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for corporate executives, employee transportation, meetings, and business journeys."
  },
  {
    question: "How can I book Goregaon to Pune Cab with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Sawant",
    feedback: "The Goregaon to Pune cab service was excellent with timely pickup, a clean vehicle, and a professional driver. Trustline Travels made the complete journey comfortable and smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ananya Kulkarni",
    feedback: "A reliable travel experience with easy booking, polite driver service, and comfortable seating. The ride from Goregaon to Pune was convenient and stress-free.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goregaon to Pune Cab",
  "image": "https://www.trustlinetravels.com/assets/images/goregaon-to-pune-cab.webp",
  "description":
    "Book Goregaon to Pune Cab with Trustline Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Goregaon to Pune, Pimpri Chinchwad, Hinjewadi, Pune Railway Station, and other Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/goregaon-to-pune-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Goregaon to Pune Cab | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Goregaon to Pune Cab with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Goregaon to Pune, Pimpri Chinchwad, Hinjewadi, Pune Railway Station, and nearby areas with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Goregaon to pune pimpri chinchwad cab, goregaon to pune one way cab, goregaon to pune taxi service, Taxi Service in Goregaon Mumbai, Cabs Service Goregaon Mumbai, malad to pune cab services, Oshiwara Andheri to Pune taxi booking, Goregaon to Hinjewadi cabs, goregaon to pune station cabs, Goregaon to Pune Station taxi fare, taxi services from Goregaon to Pune Station, innova crysta on rent goregaon Mumbai, cabs service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/109.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goregaontopunecabs;